import IBAN from 'iban';

function extendIban (validator) {
  validator.extend('iban', {
    validate: value => {
      return IBAN.isValid(value.replace(/ /g, ''));
    }
  });
}
export default extendIban;
